import { SubmissionsGallery } from '@/components/submissions';

import { useChallengeDetailContext } from './challengeDetailContext';

/**
 * Per-challenge submissions review surface. Renders the shared
 * {@link SubmissionsGallery} scoped to this challenge (its filter is fixed
 * and hidden), giving facilitators the same status pills, cards, and review
 * drawer they get on the event-level Submissions tab.
 */
export function EventChallengeSubmissionsTab() {
  const { eventId, challengeId } = useChallengeDetailContext();

  return <SubmissionsGallery eventId={eventId} fixedChallengeId={challengeId} />;
}
